import { useState } from 'react';
import { MantineProvider } from '@mantine/core';
import { QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './controllers/session-context.jsx';
import { makeQueryClient } from './models/query-client.js';
import { theme } from './views/theme.js';

export function Providers({ children, queryClient: suppliedClient, env }) {
  const [client] = useState(() => suppliedClient || makeQueryClient());
  return <MantineProvider theme={theme} defaultColorScheme="light" env={env}>
    <QueryClientProvider client={client}><SessionProvider>{children}</SessionProvider></QueryClientProvider>
  </MantineProvider>;
}
